import Component from "../abstracts/Component";
import _ from "lodash";

export default class DoubleLaunchComponent extends Component {

    get SELECTORS() {
        return {
            doubleLaunch: ".w-double-launch",
            title: ".w-double-launch-title",
        }
    }

    constructor(compEl) {
        super(compEl);
        this.doubleLaunch = document.querySelectorAll(this.SELECTORS.doubleLaunch);
        this.title = document.querySelectorAll(this.SELECTORS.title);
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollPosition = [];
        this.doubleLaunch.forEach(() => this.scrollPosition.push(0));
    }

    initComponent() {
        window.addEventListener('scroll', _.debounce(this.handleScroll, 50));
    }

    getCoords(elem) {
        let box = elem.getBoundingClientRect();
      
        return {
          top: box.top,
          right: box.right,
          bottom: box.bottom,
          left: box.left,
          width: box.width,
          height: box.height
        };
    }

    handleScroll() {
        if (this.doubleLaunch && this.doubleLaunch.length) {
            this.doubleLaunch.forEach((elem, index) => {
                if (this.title[index]) {
                    const coords = this.getCoords(elem);
                    const componentTop = coords.top;
                    const windowHeight = window.innerHeight;
                    if ((componentTop < windowHeight) && (this.scrollPosition[index] < window.scrollY)) {
                        let perc = 100 - (componentTop / windowHeight * 100);
                        if (perc > 50) perc = 50;
                        this.title[index].style.top = `${perc}%`;
                        this.scrollPosition[index] = window.scrollY;
                    }
                }
            })
        }
    }

    render() {
        super.render();
        this.initComponent();
    }

    destroy() {
        window.removeEventListener('scroll', this.handleScroll);
        super.destroy();
    }
}
